import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  tabsWrapper: {
    display: 'flex'
  }
})

export default useStyles
